import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ebc6490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-box" }
const _hoisted_2 = { class: "form-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center"
}

import { reactive, onMounted, computed } from 'vue';
  import { authStore } from '@/stores';
  import { useI18n } from 'vue-i18n';
  import { request, alert, confirm } from '@/utils';
  import { IUser } from '@/types/user';
  import { useRouter, useRoute } from 'vue-router';
  import FormComponent from '@/views/signup/components/form.vue';
  import AccountDditForm, { SubmitData } from './components/account-edit-form.vue';
  import JaFormComponent from '@/views/signup/components/ja-form.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();
  const route = useRoute();
  const router = useRouter();
  const form = reactive<{ [propName: string]: any; }>({});
  const editNav = [
    { name: t('Basic information'), key: 'basic' },
    { name: t('Email information'), key: 'email' },
    { name: t('Password information'), key: 'password' },
  ];

  const type = computed(() => {
    return {
      basic: 'basic',
      email: 'email',
      password: 'password',
    }[route.query.type as string] || 'basic';
  });

  const init = async () => {
    await authStore.tryFetchData();
    update();
  };

  function update() {
    const profile: { [key: string]: any } = authStore.user?.profile || {};
    Object.keys(profile).forEach(key => {
      form[key] = profile[key];
    });
  }

  async function handleSubmit(body: any) {
    const { data } = await request.put<IUser>('/mine', body);
    authStore.user = data;
    update();
    alert({ title: t('Success'), content: t('Operation success'), });
    router.replace({ name: 'mine.memberProfile' });
  }

  async function handleSubmitAccount(data: SubmitData) {
    const params = data.form;
    if (data.type === 'password') {
      await request.post('/password', params);
      alert({ title: t('Success'), content: t('Successful authentication'), });
      router.replace({ name: 'login' });
    } else {
      // 邮箱修改、验证
      await request.post('/mine/verify_email_address', params);
      alert({ title: t('Success'), content: t('Successful authentication'), });
      form.verification_code = null;
      // 邮箱验证没有返回更新后的数据，故重新请求接口
      await authStore.fetchData();
      update();
      router.replace({ name: 'mine.memberProfile' });
    }
  }

  async function handleDelete() {
    await confirm(t('Delete confirm'));
    router.push({ name: 'mine.memberProfile.delete' });
  }

  onMounted(init);

return (_ctx: any,_cache: any) => {
  const _component_AppNavbar = _resolveComponent("AppNavbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppNavbar, { navbar: editNav }),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(locale) === 'ja' ? JaFormComponent : FormComponent), { onSubmit: handleSubmit }, null, 512)), [
        [_vShow, _unref(type) === 'basic']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(AccountDditForm, {
          form: _unref(form),
          type: "email",
          onSubmit: handleSubmitAccount
        }, null, 8, ["form"])
      ], 512), [
        [_vShow, _unref(type) === 'email']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(AccountDditForm, {
          form: _unref(form),
          type: "password",
          onSubmit: handleSubmitAccount
        }, null, 8, ["form"])
      ], 512), [
        [_vShow, _unref(type) === 'password']
      ]),
      (_unref(locale) === 'ko')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", {
              class: "delete-link",
              onClick: handleDelete
            }, _toDisplayString(_unref(t)('Delete Terracycle Account?')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})